import { render, staticRenderFns } from "./CoverageCodes.vue?vue&type=template&id=59d5f33e&scoped=true&"
import script from "./CoverageCodes.vue?vue&type=script&lang=js&"
export * from "./CoverageCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d5f33e",
  null
  
)

export default component.exports